import React from "react";
import { BrowserRouter, Redirect, Route, Switch } from "react-router-dom";
import { useSelector } from "react-redux";

// layout constants
import { LayoutTypes } from "../constants/layout";

// strore
import { RootState } from "../redux/store";

// All layouts containers
import DefaultLayout from "../layouts/Default";
import VerticalLayout from "../layouts/Vertical";
import DetachedLayout from "../layouts/Detached";
import HorizontalLayout from "../layouts/Horizontal/";
import TwoColumnLayout from "../layouts/TwoColumn/";

import {
  authProtectedFlattenRoutes,
  publicProtectedFlattenRoutes,
} from "./index";

import RedirectProd from "../pages/auth/Redirect";
import Erro404Alt from "../pages/auth/Erro404Alt";

import { APICore } from "../helpers/api/apiCore";
import { WeeklyPulseModal } from "components/WeeklyPulseModal";
import { WeeklyAutoavaliacaoModal } from "components/WeeklyAutoavaliacaoModal";

interface RoutesProps {}

const Routes = (props: RoutesProps) => {
  const { layout } = useSelector((state: RootState) => ({
    layout: state.Layout,
  }));

  const getLayout = () => {
    let layoutCls = TwoColumnLayout;

    switch (layout.layoutType) {
      case LayoutTypes.LAYOUT_HORIZONTAL:
        layoutCls = HorizontalLayout;
        break;
      case LayoutTypes.LAYOUT_DETACHED:
        layoutCls = DetachedLayout;
        break;
      case LayoutTypes.LAYOUT_VERTICAL:
        layoutCls = VerticalLayout;
        break;
      default:
        layoutCls = TwoColumnLayout;
        break;
    }
    return layoutCls;
  };

  let Layout = getLayout();

  const api = new APICore();

  return (
    <BrowserRouter>
      {       
        api.isUserAuthenticated() && 
        <>
        <WeeklyPulseModal />
        <WeeklyAutoavaliacaoModal/>
        </>
      }
      <Switch>
        <Route
          path="/precadastro-paciente"
          exact={true}
          component={RedirectProd}
        />
        <Route path={publicProtectedFlattenRoutes.map((r: any) => r["path"])}>
          <DefaultLayout {...props} layout={layout}>  
            <Switch>
              {publicProtectedFlattenRoutes.map((route: any, index: number) => {
                return (
                  !route.children && (
                    <route.route
                      key={index}
                      path={route.path}
                      roles={route.roles}
                      exact={route.exact}
                      component={route.component}
                    />
                  )
                );
              })}
            </Switch>
          </DefaultLayout>
        </Route>
        {!api.isUserAuthenticated() ? (
          <Redirect exact from="/" to="/login" />
        ) : null}
        {!api.isUserAuthenticated() ? <Redirect from="*" to="404" /> : null}
        <Route path={authProtectedFlattenRoutes.map((r: any) => r["path"])}>
 
          <Layout {...props}>
            <Switch>
              {authProtectedFlattenRoutes.map((route: any, index: number) => {
                return (
                  !route.children && (
                    <route.route
                      key={index}
                      path={route.path}
                      roles={route.roles}
                      exact={route.exact}
                      component={route.component}
                      funcao={route.funcao}
                      funcoes={route.funcoes}
                    />
                  )
                );
              })}
              <Route path="*" component={Erro404Alt} />
            </Switch>
          </Layout>
        </Route>
      </Switch>
    </BrowserRouter>
  );
};

export default Routes;
